import React, { Fragment, useEffect, useState } from 'react';
import LightBox from '@bit/gerenciatd.unifiedcomponents.light-box';

const WrapperLightBox = (props) => {
  useEffect(() => {
    if (props.visible) {
      LightBox.show();
    }
  }, []);
  return (
    <LightBox {...props} />
  );
};

export default WrapperLightBox;
